module.exports = __webpack_public_path__ + "img/infoImg-1.e4faa717.jpg";